<template>
  <transition name="slide-fade" mode="out-in">
    <v-app v-if="$app.state == 'loading'" key="loading">
      <loading-bar></loading-bar>
    </v-app>
    <v-app v-if="$app.state == 'ready' || $app.state == 'signin'" key="ready">
      <!-- SYSTEM BAR -->
      <v-system-bar v-if="$app.systemBar.show" app color="orange">
        <v-spacer></v-spacer>
        <strong>{{ $app.systemBar.text }}</strong>
        <v-spacer></v-spacer>
        <v-icon>mdi-wifi-strength-4</v-icon>
        <v-icon>mdi-signal-cellular-outline</v-icon>
        <v-icon>mdi-battery</v-icon>
        <span>12:30</span>
      </v-system-bar>
      <!-- TOPTOOLBAR -->
      <v-app-bar
        app
        :color="$app.topToolBar.color"
        v-if="$app.topToolBar.show"
        :flat="$app.topToolBar.flat"
        :extended="$app.topToolBar.extended"
        :dense="$app.topToolBar.dense"
        :class="{ hide: !$app.topToolBar.show }"
      >
        <v-app-bar-nav-icon @click.stop="drawer.open = !drawer.open" />
        <v-toolbar-title>{{ $app.name }}</v-toolbar-title>

        <v-spacer></v-spacer>

        <!-- {{$i18n.locale}} -->
        <!-- <v-btn-toggle
        v-if="$app.config.multiLang == true"
        background-color="red"
        dense
        borderless
        v-model="lang"
        mandatory
      >
        <v-btn @click="changeLanguage('en')">EN</v-btn>
        <v-btn @click="changeLanguage('fr')">FR</v-btn>
      </v-btn-toggle> -->
        <!-- <v-app-bar-nav-icon @click.stop="rightDrawer = !rightDrawer" /> -->
        {{ drawer.open }}
      </v-app-bar>
      <!-- LEFT/MAIN NAVIGATION DRAWER  -->
      <div
        v-if="$app.user.loggedIn"
        class="nav-hover"
        :class="{ close: !drawer.open }"
        @mouseenter="hoverOverNav('enter')"
        @mouseleave="hoverOverNav('leave')"
      >
        <v-navigation-drawer
          id="main-navigation"
          class="elevation-0"
          app
          floating
          permanent
          v-model="drawer.open"
          :mini-variant="!drawer.open"
          :style="{ background: $app.color.sideNavPanel }"
        >
          <v-list>
            <v-list-item class="px-2" v-if="$app.logo">
              <v-list-item-avatar>
                <transition name="fade">
                  <v-img :src="$app.logo"></v-img>
                </transition>
              </v-list-item-avatar>
            </v-list-item>
            <v-list-item link>
              <v-list-item-icon v-if="render" class="mr-0">
                <transition name="fade" v-if="$app.icon">
                  <img
                    class="nav-icon"
                    :src="$app.icon"
                    width="35px"
                    height="35px"
                  />
                </transition>
                <transition name="fade" v-else
                  ><!-- default icon if not declared -->
                  <v-icon v-if="!drawer.open">mdi-arch</v-icon>
                </transition>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="text-h6 text-center">
                  {{ $app.name }}
                </v-list-item-title>
                <v-list-item-subtitle class="text-center">{{
                  $app.subtitle
                }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn icon @click.stop="drawer.pinned = !drawer.pinned">
                  <v-icon
                    v-if="drawer.pinned"
                    small
                    v-tooltip="{
                      content: 'Unpin Side Panel',
                      delay: { show: 500 },
                    }"
                    >mdi-pin-outline</v-icon
                  >
                  <v-icon
                    small
                    v-else
                    v-tooltip="{
                      content: 'Pin to Keep Open',
                      delay: { show: 300 },
                    }"
                    >mdi-pin-off-outline</v-icon
                  >
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>

          <v-divider></v-divider>

          <!-- MAIN NAV LINKS -->
          <v-list nav class="pa-0">
            <template v-for="(item, index) in mainMenu">
              <!-- REGULAR ITEM -->
              <v-list-item
                v-if="!item.subgroup && item.title != 'Profile'"
                :link="item.to != null"
                :to="item.to"
                :router="item.to"
                :dense="item.dense"
                :key="index"
                class="px-4 rounded-0"
              >
                <v-list-item-icon v-if="item.icon" class="mr-3">
                  <v-badge
                    :value="item.badge || false"
                    color="green accent-4"
                    :content="item.badge || null"
                    overlap
                    right
                    transition="slide-x-transition"
                  >
                    <v-icon v-text="item.icon"></v-icon>
                  </v-badge>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                  <v-list-item-subtitle v-if="item.subtitle">{{
                    item.subtitle
                  }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-icon v-if="item.afterIcon">
                  <v-icon v-text="item.afterIcon"></v-icon>
                </v-list-item-icon>
              </v-list-item>
              <!-- PROFILE ITEM -->
              <v-list-item
                v-if="item.title == 'Profile'"
                @click="showHide.userProfile = true"
                :dense="item.dense"
                :key="index"
                class="px-4 rounded-0"
              >
                <v-list-item-icon v-if="item.icon" class="mr-3">
                  <v-badge
                    :value="item.badge || false"
                    color="green accent-4"
                    :content="item.badge || null"
                    overlap
                    right
                    transition="slide-x-transition"
                  >
                    <v-icon v-text="item.icon"></v-icon>
                  </v-badge>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                  <v-list-item-subtitle v-if="item.subtitle">{{
                    item.subtitle
                  }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-icon v-if="item.afterIcon">
                  <v-icon v-text="item.afterIcon"></v-icon>
                </v-list-item-icon>
              </v-list-item>
              <!-- DROPDOWN ITEMS -->
              <v-list-group
                v-if="item.subgroup"
                :value="item.open"
                :key="index"
                class="nav-subgroup"
              >
                <template v-slot:activator>
                  <v-list-item-icon v-if="item.icon" class="mr-3 pl-2">
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-title class="pl-2">{{
                    item.title
                  }}</v-list-item-title>
                  <v-list-item-subtitle class="pl-2" v-if="item.subtitle">{{
                    item.subtitle
                  }}</v-list-item-subtitle>
                </template>
                <!-- ITEM SUBGROUP -->
                <div v-for="(_item, index) in item.subgroup" :key="index">
                  <v-list-item
                    :link="_item.to != null"
                    :to="_item.to"
                    :dense="_item.dense"
                    class="pl-3 rounded-0"
                  >
                    <v-list-item-icon class="px-3">
                      <v-icon v-if="_item.icon" v-text="_item.icon"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{ _item.title }}</v-list-item-title>
                      <v-list-item-subtitle v-if="_item.subtitle">{{
                        _item.subtitle
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-icon v-if="_item.afterIcon">
                      <v-icon v-text="_item.afterIcon"></v-icon>
                    </v-list-item-icon>
                  </v-list-item>
                </div>
              </v-list-group>
            </template>
          </v-list>

          <!-- DEVELOPMENT NAV LINKS -->
          <div v-if="devMode">
            <template v-for="(item, index) in devMenu">
              <!-- REGULAR ITEM -->

              <v-list-item
                v-if="!item.subgroup"
                :link="item.to != null"
                :to="item.to"
                :router="item.to"
                :dense="item.dense"
                :key="index"
              >
                <v-list-item-icon v-if="item.icon" class="mr-3">
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                  <v-list-item-subtitle v-if="item.subtitle">{{
                    item.subtitle
                  }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-icon v-if="item.afterIcon">
                  <v-icon v-text="item.afterIcon"></v-icon>
                </v-list-item-icon>
              </v-list-item>
              <!-- DROPDOWN ITEMS -->
              <v-list-group
                v-if="item.subgroup"
                :value="item.open"
                :key="index"
              >
                <template v-slot:activator>
                  <v-list-item-icon v-if="item.icon" class="mr-3">
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                  <v-list-item-subtitle v-if="item.subtitle">{{
                    item.subtitle
                  }}</v-list-item-subtitle>
                </template>
                <div v-for="(_item, index) in item.subgroup" :key="index">
                  <v-list-item
                    :link="_item.to != null"
                    :to="_item.to"
                    :dense="_item.dense"
                  >
                    <v-list-item-icon class="mx-3">
                      <v-icon v-if="_item.icon" v-text="_item.icon"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{ _item.title }}</v-list-item-title>
                      <v-list-item-subtitle v-if="_item.subtitle">{{
                        _item.subtitle
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-icon v-if="_item.afterIcon">
                      <v-icon v-text="_item.afterIcon"></v-icon>
                    </v-list-item-icon>
                  </v-list-item>
                </div>
              </v-list-group>
            </template>
          </div>

          <!-- SETTINGS NAV LINKS -->
          <v-list nav class="settings">
            <v-list-item
              v-if="devMode"
              dense
              link
              @click="$root.$i18n.locale = langToggle"
            >
              <v-list-item-icon class="mr-3">
                <v-icon>mdi-google-translate</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  <span v-if="$root.$i18n.locale != 'en'">English</span>
                  <span v-else>Francais</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item dense link @click="$app.signOut">
              <v-list-item-icon class="mr-3">
                <v-icon>mdi-logout-variant</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>SIGN OUT</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-navigation-drawer>
      </div>

      <!-- MAIN ROUTER VIEW -->
      <v-main
        :style="{
          background: $app.color.background,
        }"
        ref="app_wrapper"
      >
        <transition :name="transitionName" mode="out-in">
          <router-view />
        </transition>
        <!-- USER PROFILE -->

        <user-profile v-model="showHide.userProfile"></user-profile>
      </v-main>

      <!-- ALERT MODAL -->
      <v-snackbar
        v-model="$root.alert.snackbar"
        :bottom="$root.alert.y === 'bottom'"
        :color="$root.alert.color"
        :left="$root.alert.x === 'left'"
        :multi-line="$root.alert.mode === 'multi-line'"
        :centered="$root.alert.centered"
        :right="$root.alert.x === 'right'"
        :timeout="$root.alert.timeout"
        :top="$root.alert.y === 'top'"
        :vertical="$root.alert.mode === 'vertical'"
      >
        {{ $root.alert.text }}
        <template v-slot:action="{ attrs }">
          <v-btn
            :dark="$root.alert.dark"
            text
            v-bind="attrs"
            @click="$root.alert.snackbar = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-app>
    <!-- <v-app v-if="$app.state == 'signin'">
      <SignIn />
    </v-app> -->
  </transition>
</template>

<script>
/* eslint-disable no-unused-vars */
import SaninnLogger from "@/config/debugger";
import SignIn from "./modules/Auth/SignIn_.vue";
import userProfile from "./modules/userProfile/userProfile.view.vue";
const debug = new SaninnLogger("App.vue", false);

export default {
  name: "App",
  data: () => ({
    logo: require("./assets/npc_logo.png"),
    //devMode: process.env.NODE_ENV === "development" ? true : false,
    devMode: true,
    transitionName: "fade",
    render: true,
    // left drawer
    hover: false,
    drawer: {
      show: false,
      open: true,
      pinned: true,
    },
    lang: "en",
    prevHeight: 0,
    showHide: {
      userProfile: false,
      signOut: true,
    },
    mainMenu: [
      {
        title: "Dashboard",
        subtitle: null,
        to: "/dashboard",
        icon: "mdi-view-dashboard",
        afterIcon: null,
      },
      {
        title: "Profile",
        subtitle: null,
        icon: "mdi-android-messages",
        afterIcon: null,
      },
      // {
      //   title: "Messages",
      //   subtitle: null,
      //   to: "/Messages",
      //   icon: "mdi-android-messages",
      //   afterIcon: null,
      //   badge: 2,
      // },
      {
        title: "Contacts",
        subtitle: null,
        icon: "mdi-contacts",
        to: "/contacts",
        dense: false, // or null
        open: false,
        // subgroup: [
        //   {
        //     title: "All",
        //     subtitle: null,
        //     to: "/contacts",
        //     icon: "mdi-contacts-outline",
        //     afterIcon: null,
        //     dense: false, // or null
        //   },
        //   {
        //     title: "Organizations",
        //     subtitle: null,
        //     to: "/organizations",
        //     icon: "mdi-domain",
        //     afterIcon: null,
        //     dense: false, // or null
        //   },

        //   {
        //     title: "Groups",
        //     subtitle: null,
        //     to: "/groups",
        //     icon: "mdi-account-group",
        //     afterIcon: null,
        //     dense: false, // or null
        //   },
        // ],
      },
      {
        title: "Posts",
        subtitle: null,
        icon: "mdi-post-outline",
        to: "/posts",
        dense: false, // or null
      },
      {
        title: "Calendar",
        subtitle: null,
        icon: "mdi-calendar",
        to: "/calendar",
        dense: false, // or null
      },
      {
        title: "Media",
        subtitle: null,
        icon: "mdi-image",
        to: "/medias",
        dense: false, // or null
      },
      // {
      //   title: "Games",
      //   subtitle: null,
      //   icon: "mdi-gamepad",
      //   to: "/games",
      //   dense: false, // or null
      // },
      {
        title: "Forms & Agreements",
        subtitle: null,
        icon: "mdi-file-document-multiple-outline",
        afterIcon: null,
        subgroup: [
          {
            title: "Forms",
            subtitle: null,
            to: "/smart-forms",
            icon: "mdi-file-document-multiple-outline",
            dense: false, // or null
          },
          // AGREEMENTS
          {
            title: "Agreements",
            subtitle: null,
            icon: "mdi-file-document-edit",
            to: "/agreements-demo",
            dense: false, // or null
          },
        ],
      },
      {
        title: "About NPC Canada",
        subtitle: null,
        icon: "mdi-leaf-maple",
        to: "/about-npc-canada",
        dense: false, // or null
      },
      {
        title: "Permissions Groups",
        subtitle: null,
        icon: "mdi-account-group",
        to: "/permissions",
        dense: false,
      },
      // {
      //   title: "Settings",
      //   subtitle: null,
      //   icon: "mdi-cog",
      //   to: "/settings",
      //   dense: false, // or null
      // },
    ],
    devMenu: [
      // {
      //   title: "Developers",
      //   subtitle: null,
      //   icon: "mdi-blur",
      //   dense: true, // or null
      //   open: false,
      //   subgroup: [
      //     {
      //       title: "Loading Page",
      //       subtitle: null,
      //       // icon: "mdi-cog",
      //       to: "/",
      //       dense: true,
      //     },
      //     {
      //       title: "Demos",
      //       subtitle: null,
      //       // icon: "mdi-cog",
      //       to: "/demos/",
      //       dense: true,
      //     },
      //     {
      //       title: "Site-Info",
      //       subtitle: null,
      //       // icon: "mdi-cog",
      //       to: "/site-info",
      //       dense: true,
      //     },

      //     {
      //       title: "User Profiles",
      //       subtitle: null,
      //       to: "/profiles",
      //       dense: true,
      //     },
      //     {
      //       title: "Dashboard V2",
      //       subtitle: null,
      //       to: "/dashboard-v2",
      //       dense: true,
      //     },
      //     {
      //       title: "Media Tester",
      //       subtitle: null,
      //       to: "/media-tester",
      //       dense: true,
      //     },
      //   ],
      // },
    ],
  }),
  computed: {
    langToggle() {
      let lang = this.$root.$i18n.locale;
      let alternateLang = lang === "en" ? "fr" : "en";
      return alternateLang;
    },
  },
  methods: {
    init() {
      this.drawer.show = true;
      this.transitionName = "slide-right";
    },
    checkBadge(item) {
      if (!item) {
        return false;
      } else {
        return;
      }
    },
    reRender() {
      this.render = false;
      this.$nextTick(() => {
        this.render = true;
      });
    },
    hoverOverNav(event) {
      this.$nextTick(() => {
        if (!this.drawer.pinned && event == "leave") {
          this.drawer.open = false;
        } else if (!this.drawer.open && event == "enter") {
          this.drawer.open = true;
        }
      });
    },
  },
  components: {
    LoadingBar: () => import("./components/LoadingBar.vue"),
    userProfile,
  },
  mounted() {
    debug.log("App this", this);
    //console.log(process.env.NODE_ENV);
    // TODO: Will be replaced by data load promise
    let loadtime = this.devMode == true ? 0 : 2000;
    setTimeout(() => this.init(), loadtime);
  },
  created() {
    document.title = this.$app.name;
  },
};
</script>
<style lang="scss">
.v-list.settings.v-sheet.v-list--nav {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

.nav-icon {
  position: relative;
  left: -5px;
}

.nav-hover {
  position: absolute;
  display: inline-block;
  background: none;
  // size prevents 'jitter' transitionName when hovering
  height: 100%;
  width: 260px;
  z-index: 10;
  &.close {
    width: 58px;
  }
}

.nav-subgroup {
  .v-list--nav .v-list-item,
  .v-list--nav .v-list-item:before {
    border-radius: 0px !important;
  }
  // GROUP/DROPDOWN STYLE
  .v-list-group__header {
    margin-bottom: 0px !important;
  }
  .v-list-group__items {
    position: relative;
  }
  .v-list-group__items::before {
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;
    border-radius: 0px;
    -webkit-box-shadow: inset 0px 0px 21px 10px rgba(0, 0, 0, 0.1);
    -moz-box-shadow: inset 0px 0px 21px 10px rgba(0, 0, 0, 0.1);
    box-shadow: inset 0px 0px 21px 10px rgba(0, 0, 0, 0.1);
  }
}

.theme--light.v-navigation-drawer {
  background-color: #fdfdfd;
}

// gives main elevation effect over left nav
.v-main__wrap {
  box-shadow: 0px 3px 3px -2px rgb(0 0 0 / 20%),
    0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%) !important;
  z-index: 999;
}
</style>
